import { OpenCallTypeUiConfig, OPEN_CALL_TYPE_IDS } from '../types';
import { openCastingUiConfig } from '../open-casting/ui-config';
import { getLegacyCandidateAboutConfig } from '../shared/candidate-about';

export const americanStyleUiConfig: OpenCallTypeUiConfig = {
  ...openCastingUiConfig,
  typeId: OPEN_CALL_TYPE_IDS.AmericanStyle,

  candidateDetails: {
    ...openCastingUiConfig.candidateDetails,
    about: getLegacyCandidateAboutConfig('Occupation'),
    showAttributes: false,
    parseBioAsQa: true,
  },
};
